module.exports = __webpack_public_path__ + "img/icon.ef999935.png";